import { connect } from 'react-redux';
import get from 'lodash/get';

import FAQ from '../components/FAQ';
import getData from 'shared/blocks/smart-faq/selectors/getData';
import { FALLBACK_HTML } from 'shared/blocks/smart-faq/constants';

const mapStateToProps = (state: any) => {
  const { bySlug, currentSlug } = getData(state);

  const current = bySlug[currentSlug];

  return {
    loading: get(current, 'loading', true),
    html: get(current, 'data', FALLBACK_HTML),
    currentSlug
  };
};

export default connect(mapStateToProps)(FAQ);
